module.exports = __webpack_public_path__ + "img/icdeposit.b8e5773c.png";